import { RootState } from '../../reducers';
import { studentFinderActionsInterfaces } from '.';

export const getStudentListData =
  (state: RootState): Array<SingleObjectDataStructure> => state.StudentFinder.studentList;

export const getSelectOpenStatus =
  (state: RootState): boolean => state.StudentFinder.selectOpen;

export const getLoadingStatus =
  (state: RootState): boolean => state.StudentFinder.loading;

export const getSingleStudent =
  (state: RootState): SingleObjectDataStructure | undefined => state.StudentFinder.singleStudent;

export const getSubjectList =
  (state: RootState): studentFinderActionsInterfaces.SubjectForStudentList => state.StudentFinder.subjectForStudentList;
